var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 71,
    viewBox: "0 0 180 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_631_31)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M162.301 57.6492H17.9723C14.7394 57.6492 12.1992 55.109 12.1992 51.876V17.2372C12.1992 14.0042 14.7394 11.464 17.9723 11.464H162.301C165.534 11.464 168.074 14.0042 168.074 17.2372V51.876C168.074 55.109 165.534 57.6492 162.301 57.6492Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.9287 23.2413C66.9287 24.165 66.6978 24.9733 66.1205 25.5506C65.4277 26.2433 64.6195 26.5897 63.5803 26.5897C62.5411 26.5897 61.7329 26.2433 61.0401 25.5506C60.3473 24.8578 60.001 24.0495 60.001 23.0104C60.001 21.9712 60.3473 21.163 61.0401 20.4702C61.7329 19.7774 62.5411 19.431 63.5803 19.431C64.0422 19.431 64.504 19.5465 64.9659 19.7774C65.4277 20.0083 65.7741 20.2393 66.005 20.5857L65.4277 21.163C64.9659 20.5857 64.3885 20.3547 63.5803 20.3547C62.8875 20.3547 62.1948 20.5857 61.7329 21.163C61.1556 21.6248 60.9247 22.3176 60.9247 23.1258C60.9247 23.9341 61.1556 24.6269 61.7329 25.0887C62.3102 25.5506 62.8875 25.897 63.5803 25.897C64.3885 25.897 64.9659 25.666 65.5432 25.0887C65.8896 24.7423 66.1205 24.2805 66.1205 23.7032H63.5803V22.7795H66.9287V23.2413ZM72.24 20.3547H69.1225V22.5485H72.0091V23.3568H69.1225V25.5506H72.24V26.4743H68.1988V19.5465H72.24V20.3547ZM76.0503 26.4743H75.1266V20.3547H73.1637V19.5465H78.0132V20.3547H76.0503V26.4743ZM81.3616 26.4743V19.5465H82.2853V26.4743H81.3616ZM86.211 26.4743H85.2873V20.3547H83.3245V19.5465H88.0585V20.3547H86.0956V26.4743H86.211ZM97.18 25.5506C96.4872 26.2433 95.679 26.5897 94.6398 26.5897C93.6007 26.5897 92.7924 26.2433 92.0997 25.5506C91.4069 24.8578 91.0605 24.0495 91.0605 23.0104C91.0605 21.9712 91.4069 21.163 92.0997 20.4702C92.7924 19.7774 93.6007 19.431 94.6398 19.431C95.679 19.431 96.4872 19.7774 97.18 20.4702C97.8728 21.163 98.2192 21.9712 98.2192 23.0104C98.2192 24.0495 97.8728 24.8578 97.18 25.5506ZM92.7924 24.9733C93.2543 25.4351 93.9471 25.7815 94.6398 25.7815C95.3326 25.7815 96.0254 25.5506 96.4873 24.9733C96.9491 24.5114 97.2955 23.8186 97.2955 23.0104C97.2955 22.2021 97.0646 21.5094 96.4873 21.0475C96.0254 20.5857 95.3326 20.2393 94.6398 20.2393C93.9471 20.2393 93.2543 20.4702 92.7924 21.0475C92.3306 21.5094 91.9842 22.2021 91.9842 23.0104C91.9842 23.8186 92.2151 24.5114 92.7924 24.9733ZM99.4893 26.4743V19.5465H100.528L103.877 24.9733V19.5465H104.8V26.4743H103.877L100.297 20.8166V26.4743H99.4893Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.230926,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M90.8303 36.635C88.0591 36.635 85.8653 38.7133 85.8653 41.5999C85.8653 44.371 88.0591 46.5648 90.8303 46.5648C93.6014 46.5648 95.7952 44.4865 95.7952 41.5999C95.7952 38.5979 93.6014 36.635 90.8303 36.635ZM90.8303 44.4865C89.3292 44.4865 88.0591 43.2164 88.0591 41.4844C88.0591 39.7525 89.3292 38.4824 90.8303 38.4824C92.3313 38.4824 93.6014 39.637 93.6014 41.4844C93.6014 43.2164 92.3313 44.4865 90.8303 44.4865ZM80.0922 36.635C77.3211 36.635 75.1273 38.7133 75.1273 41.5999C75.1273 44.371 77.3211 46.5648 80.0922 46.5648C82.8633 46.5648 85.0571 44.4865 85.0571 41.5999C85.0571 38.5979 82.8633 36.635 80.0922 36.635ZM80.0922 44.4865C78.5912 44.4865 77.3211 43.2164 77.3211 41.4844C77.3211 39.7525 78.5912 38.4824 80.0922 38.4824C81.5932 38.4824 82.8633 39.637 82.8633 41.4844C82.8633 43.2164 81.5932 44.4865 80.0922 44.4865ZM67.2758 38.136V40.2144H72.2407C72.1253 41.369 71.6634 42.2927 71.0861 42.87C70.3933 43.5628 69.2387 44.371 67.2758 44.371C64.1583 44.371 61.8491 41.9463 61.8491 38.8288C61.8491 35.7113 64.2738 33.2866 67.2758 33.2866C68.8923 33.2866 70.1624 33.9794 71.0861 34.7876L72.5871 33.2866C71.317 32.1319 69.7005 31.2082 67.3913 31.2082C63.2346 31.2082 59.6553 34.6721 59.6553 38.8288C59.6553 42.9855 63.2346 46.4494 67.3913 46.4494C69.7005 46.4494 71.317 45.7566 72.7026 44.2556C74.0881 42.87 74.55 40.9071 74.55 39.4061C74.55 38.9443 74.55 38.4824 74.4345 38.136H67.2758ZM119.696 39.7525C119.234 38.5979 118.079 36.635 115.539 36.635C112.999 36.635 110.921 38.5979 110.921 41.5999C110.921 44.371 112.999 46.5648 115.77 46.5648C117.964 46.5648 119.349 45.1793 119.811 44.371L118.195 43.2164C117.617 44.0246 116.925 44.6019 115.77 44.6019C114.615 44.6019 113.923 44.1401 113.345 43.1009L119.927 40.3298L119.696 39.7525ZM112.999 41.369C112.999 39.5216 114.5 38.4824 115.539 38.4824C116.347 38.4824 117.156 38.9443 117.387 39.5216L112.999 41.369ZM107.572 46.103H109.766V31.6701H107.572V46.103ZM104.108 37.6742C103.531 37.0969 102.607 36.5195 101.453 36.5195C99.0281 36.5195 96.7189 38.7133 96.7189 41.4844C96.7189 44.2556 98.9127 46.3339 101.453 46.3339C102.607 46.3339 103.531 45.7566 103.993 45.1793H104.108V45.872C104.108 47.7194 103.069 48.7586 101.453 48.7586C100.183 48.7586 99.259 47.8349 99.0281 47.0267L97.1807 47.8349C97.758 49.105 99.1436 50.7215 101.568 50.7215C104.108 50.7215 106.187 49.2205 106.187 45.6411V36.8659H104.108V37.6742ZM101.568 44.4865C100.067 44.4865 98.7972 43.2164 98.7972 41.4844C98.7972 39.7525 100.067 38.4824 101.568 38.4824C103.069 38.4824 104.224 39.7525 104.224 41.4844C104.224 43.2164 103.069 44.4865 101.568 44.4865ZM129.741 31.6701H124.545V46.103H126.739V40.6762H129.741C132.166 40.6762 134.475 38.9443 134.475 36.1731C134.475 33.402 132.166 31.6701 129.741 31.6701ZM129.857 38.5979H126.739V33.633H129.857C131.473 33.633 132.397 35.0185 132.397 36.0577C132.281 37.3278 131.358 38.5979 129.857 38.5979ZM143.135 36.5195C141.518 36.5195 139.902 37.2123 139.324 38.7133L141.287 39.5216C141.749 38.7133 142.442 38.4824 143.25 38.4824C144.405 38.4824 145.444 39.1752 145.559 40.3298V40.4453C145.213 40.2144 144.289 39.868 143.366 39.868C141.287 39.868 139.209 41.0226 139.209 43.1009C139.209 45.0638 140.941 46.3339 142.788 46.3339C144.289 46.3339 144.982 45.6411 145.559 44.9483H145.675V46.103H147.753V40.5607C147.522 38.0206 145.559 36.5195 143.135 36.5195ZM142.904 44.4865C142.211 44.4865 141.172 44.1401 141.172 43.2164C141.172 42.0618 142.442 41.7154 143.481 41.7154C144.405 41.7154 144.867 41.9463 145.444 42.1772C145.213 43.5628 144.058 44.4865 142.904 44.4865ZM155.027 36.8659L152.603 43.1009H152.487L149.947 36.8659H147.638L151.448 45.6411L149.254 50.4906H151.448L157.337 36.8659H155.027ZM135.63 46.103H137.823V31.6701H135.63V46.103Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2079 20.1238C23.8615 20.4702 23.7461 21.0475 23.7461 21.7403V47.2576C23.7461 47.9504 23.977 48.5277 24.3234 48.8741L24.4389 48.9895L38.7563 34.6721V34.4412L24.2079 20.1238Z",
    fill: "url(#paint0_linear_631_31)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3746 39.5216L38.6406 34.7876V34.4412L43.3746 29.7072L43.4901 29.8227L49.1477 33.0557C50.7642 33.9794 50.7642 35.4804 49.1477 36.4041L43.3746 39.5216Z",
    fill: "url(#paint1_linear_631_31)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4893 39.4061L38.6399 34.5567L24.207 48.9895C24.7843 49.5669 25.5926 49.5669 26.6317 49.105L43.4893 39.4061Z",
    fill: "url(#paint2_linear_631_31)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4893 29.7072L26.6317 20.1238C25.5926 19.5465 24.7843 19.662 24.207 20.2393L38.6399 34.5567L43.4893 29.7072Z",
    fill: "url(#paint3_linear_631_31)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M43.3739 39.2907L26.6317 48.7586C25.708 49.3359 24.8998 49.2205 24.3225 48.7586L24.207 48.8741L24.3225 48.9895C24.8998 49.4514 25.708 49.5669 26.6317 48.9895L43.3739 39.2907Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M24.2079 48.7586C23.8615 48.4122 23.7461 47.8349 23.7461 47.1421V47.2576C23.7461 47.9504 23.977 48.5277 24.3234 48.8741V48.7586H24.2079ZM49.1479 36.0577L43.3748 39.2907L43.4902 39.4061L49.1479 36.1732C49.9562 35.7113 50.3026 35.134 50.3026 34.5567C50.3026 35.134 49.8407 35.5958 49.1479 36.0577Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M26.6326 20.2393L49.1479 33.0557C49.8407 33.5175 50.3026 33.9794 50.3026 34.5567C50.3026 33.9794 49.9562 33.402 49.1479 32.9402L26.6326 20.1238C25.0162 19.2001 23.7461 19.8929 23.7461 21.7403V21.8557C23.7461 20.1238 25.0162 19.3156 26.6326 20.2393Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_631_31",
    x: 0.519218,
    y: 0.474039,
    width: 179.235,
    height: 69.5452,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.69
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.84
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_631_31"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_631_31",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_631_31",
    x1: 37.3707,
    y1: 21.5209,
    x2: 17.9926,
    y2: 40.8979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_631_31",
    x1: 51.2653,
    y1: 34.5578,
    x2: 23.3268,
    y2: 34.5578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_631_31",
    x1: 40.8649,
    y1: 37.2077,
    x2: 14.5878,
    y2: 63.4848,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_631_31",
    x1: 20.6242,
    y1: 11.6673,
    x2: 32.3587,
    y2: 23.4018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.069,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.d725015ccae5e8d8daa5f1d36841e2d4.svg";
export { ForwardRef as ReactComponent };